export default __webpack_public_path__ + "static/media/Logo_ColossusCloud_by-Serverpoints.13383810.svg";